"use client"

import { useUpsertCampaign } from "@/(admin)/modules/campaign/hooks/useUpsertCampaign"
import CampaignPublish from "@/(admin)/modules/campaign/pages/CampaignPublish"
import CampaignUpsertForm from "@/(admin)/modules/campaign/pages/CampaignUpsertForm"
import { FormSection, FormShell, FormSkeleton } from "@/(admin)/components/form"
import AccessDenied from "@/components/custom-access-denied"
import { CAMPAIGNS } from "@/constants/admin-paths"
import { useCheckPermission } from "@/hook/use-check-permission"
import { t } from "@/languages/i18n"

const UpsertCampaign = () => {
  const { form, isEditMode, loading, submitting, exporting, status, setStatus, handlers } = useUpsertCampaign()
  const { hasPermission: checkPermission } = useCheckPermission()

  const requiredPermission = isEditMode ? "update" : "create"

  if (!checkPermission("campaign", requiredPermission)) {
    return <AccessDenied />
  }

  if (loading && isEditMode) {
    return <FormSkeleton mainSections={2} sidebarCards={1} />
  }

  const crumbs = [
    { title: t("Chiến dịch"), href: `/admin${CAMPAIGNS.LIST.PATH}` },
    { title: isEditMode ? t("Chỉnh sửa") : t("Tạo mới") },
  ]

  const main = (
    <FormSection title={t("Thông tin chiến dịch")} collapsible={false}>
      <CampaignUpsertForm form={form} onFormChange={handlers.handleFormChange} />
    </FormSection>
  )

  const sidebar = (
    <CampaignPublish
      onSubmit={handlers.handleSubmit}
      isCreateEdit={!isEditMode}
      status={status}
      setStatus={setStatus}
      loading={submitting}
      exporting={exporting}
      onCancel={handlers.handleBack}
      onExportCsv={isEditMode ? handlers.handleExportCsv : undefined}
    />
  )

  return (
    <FormShell
      title={isEditMode ? t("Chỉnh sửa chiến dịch") : t("Thêm chiến dịch mới")}
      crumbs={crumbs}
      main={main}
      sidebar={sidebar}
    />
  )
}

export default UpsertCampaign
